import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui';
import AceEditor from 'react-ace';
import { useJsonEditorModal } from './use-json-editor-modal';

import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/theme-monokai';

export function JsonEditorModal(props: Parameters<typeof useJsonEditorModal>[0]) {
  const f = useJsonEditorModal(props);

  return (
    <Dialog open={f.open} onOpenChange={f.onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] flex flex-col">
        <DialogHeader>
          <DialogTitle>View Document JSON</DialogTitle>
          <DialogDescription>
            Document data as JSON (read-only).
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 min-h-0">
          <AceEditor
            mode="json"
            theme={f.theme}
            value={f.jsonString}
            readOnly
            width="100%"
            height="100%"
            fontSize={14}
            showPrintMargin={true}
            showGutter={true}
            highlightActiveLine={true}
            setOptions={{
              showLineNumbers: true,
              tabSize: 2,
            }}
            style={{ minHeight: '400px' }}
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={f.handleClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
